import { FieldType } from "shared/types/field";
import {
  EditableInputComponent,
  SectionEditableField,
  SectionHeader,
} from "..";

type SectionProps = {
  title: string;
  icon: any;
  fieldsConfig: any[];
  editMode: boolean;
  isLoading: boolean;
  onEditClick?: () => void;
  onSaveClick?: () => void;
  editedState?: any;
  originalState: any;
  setStateFunction?: (prev: any) => void;
  showEditToggle?: boolean;
};

type FieldProps = {
  fieldConfig: any;
  editedState: any;
  originalState: any;
  editMode: boolean;
  setStateFunction: (prev: any) => void;
  isLoading: boolean;
};

export const renderSection = ({
  title,
  icon,
  fieldsConfig,
  editMode,
  onEditClick,
  onSaveClick,
  editedState,
  originalState,
  setStateFunction = () => {},
  isLoading,
  showEditToggle = true,
}: SectionProps) => (
  <div
    key={title}
    className="divide-y divide-neutral-primary/15 rounded-md border border-neutral-primary/15 bg-white"
  >
    <SectionHeader
      title={title}
      icon={icon}
      editMode={editMode}
      onEditClick={onEditClick}
      onSaveClick={onSaveClick}
      showEditToggle={showEditToggle}
    />
    {fieldsConfig.map((fieldConfig: any) =>
      renderEditableField({
        fieldConfig,
        editMode,
        editedState,
        originalState,
        setStateFunction,
        isLoading,
      }),
    )}
  </div>
);

export const renderEditableField = ({
  fieldConfig,
  editedState,
  originalState,
  editMode,
  setStateFunction,
  isLoading,
}: FieldProps) => {
  const {
    label,
    key,
    type = FieldType.DEFAULT,
    Component = EditableInputComponent,
    mask = "",
    indentation = null,
    style = "regular",
    disableEditMode = false,
    link = "",
    linkTooltip = "",
    onBlur,
    WarningComponent,
  } = fieldConfig;

  const finalEditMode = disableEditMode ? false : editMode;

  // Determine the value, considering empty strings
  let value = editedState?.[key];
  if (value === undefined) {
    value = originalState?.[key] || "";
  }

  const handleChange = (newValue: any) => {
    setStateFunction((prev: any) => ({ ...prev, [key]: newValue }));
  };

  const componentToRender = (
    <Component
      label={label}
      type={type}
      editMode={finalEditMode}
      value={value}
      mask={mask}
      indentation={indentation}
      onChange={handleChange}
      onBlur={onBlur}
      isLoading={isLoading}
      style={style}
    />
  );

  return (
    <div key={key}>
      <SectionEditableField
        label={label}
        type={type}
        indentation={indentation}
        ComponentToRender={componentToRender}
        editMode={finalEditMode}
        value={value}
        mask={mask}
        onChange={handleChange}
        isLoading={isLoading}
        style={style}
        link={link}
        linkTooltip={linkTooltip}
      />
      {WarningComponent && <WarningComponent />}
    </div>
  );
};
